import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [superAdmin, setSuperAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("organizer_token");
    const savedSuperAdminLogin = localStorage.getItem("super_admin_login_id");
    const savedSuperAdminToken = localStorage.getItem("super_admin_token");

    if (savedSuperAdminLogin && savedSuperAdminToken) {
      setSuperAdmin({
        login_id: savedSuperAdminLogin,
        token: savedSuperAdminToken,
      });
    }

    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("organizer_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, organizer) => {
    localStorage.setItem("organizer_token", token);
    setUser(organizer);
  };

  const logout = () => {
    localStorage.removeItem("organizer_token");
    setUser(null);
  };

  const superAdminLogin = ({ login_id, token }) => {
    localStorage.setItem("super_admin_login_id", login_id);
    localStorage.setItem("super_admin_token", token);
    setSuperAdmin({ login_id, token });
  };

  const superAdminLogout = () => {
    localStorage.removeItem("super_admin_login_id");
    localStorage.removeItem("super_admin_token");
    setSuperAdmin(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        superAdmin,
        superAdminLogin,
        superAdminLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
